export default __webpack_public_path__ + "static/media/webAiKit.a0e9b230.png";